import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { faArrowsUpDownLeftRight } from '@fortawesome/free-solid-svg-icons/faArrowsUpDownLeftRight';
import React from 'react';
import styled from 'styled-components';

import { Breakpoints } from '../../theme/Breakpoints';
import { Spacing } from '../../theme/Spacing';
import { AtiraIcon } from '../AtiraIcon';
import { Flex } from '../Flex';

const StyledContainer = styled(Flex)`
  width: 100%;
  position: relative;
`;

const StyledDraggable = styled.div<{ disabled?: boolean }>`
  position: absolute;
  inset-block: 0;
  inset-inline-start: calc(${Spacing.s} * 1.5);
  align-content: center;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};

  &:hover {
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'grab')};
  }

  display: none;

  @media (min-width: ${Breakpoints.DESKTOP}) {
    display: block;
  }
`;

type SortableChildProps = {
  id: string;
  children?: React.ReactNode;
  disabled?: boolean;
  className?: string;
};

export const SortableChild: React.FC<SortableChildProps> = ({
  id,
  children,
  disabled = false,
  className,
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id, disabled });

  const localStyle = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <StyledContainer ref={setNodeRef} style={localStyle} className={className}>
      <Flex flex={1} width={'100%'}>
        {children}
      </Flex>
      <StyledDraggable disabled={disabled} {...attributes} {...listeners}>
        <AtiraIcon color="main" icon={faArrowsUpDownLeftRight} size={'xl'} />
      </StyledDraggable>
    </StyledContainer>
  );
};
